import { createFileRoute, redirect } from '@tanstack/react-router';

const SuperadminSettingsIndexRoute = () => null;

export const Route = createFileRoute('/_authenticated/superadmin/settings/')({
  component: SuperadminSettingsIndexRoute,
  beforeLoad: () => {
    throw redirect({ to: '/superadmin/settings/profile' });
  },
});
